import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { Toaster } from 'sonner';
import { TooltipProvider } from '@/components/ui/misc';
import { ConfirmProvider } from '@/components/ui/overlay';
import { AuthProvider } from '@/lib/auth';
import { I18nProvider, useI18n } from '@/lib/i18n';
import { queryClient } from '@/lib/query';
import { ThemeProvider, useTheme } from '@/lib/theme';

function Toasts() {
  const { theme } = useTheme();
  const { dir } = useI18n();
  return <Toaster theme={theme} dir={dir} position={dir === 'rtl' ? 'bottom-left' : 'bottom-right'} richColors closeButton toastOptions={{ className: 'font-sans' }} />;
}

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <ThemeProvider>
          <AuthProvider>
            <TooltipProvider delayDuration={250}>
              <ConfirmProvider>
                {children}
                <Toasts />
              </ConfirmProvider>
            </TooltipProvider>
          </AuthProvider>
        </ThemeProvider>
      </I18nProvider>
    </QueryClientProvider>
  );
}
